// Need to use the React-specific entry point to import createApi
import { baseApi } from "./baseApi";

// using CSRF token from Local Storage

// Define a service using a base URL and expected endpoints
export const driverApi = baseApi.injectEndpoints({
  reducerPath: "driverApi",
  endpoints: (builder) => ({
    getAllDriver: builder.query({
      query: (query) => {
        let queryString = new URLSearchParams(query).toString();
        return {
          url: `driver?${queryString}`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      providesTags: ["driver"],
    }),
    addDriver: builder.mutation({
      query: (modifiedData) => {
        return {
          url: `driver`,
          method: "POST",
          body: modifiedData,
        };
      },
      invalidatesTags: ["driver"],
    }),
    updateDriver: builder.mutation({
      query: ({ id, modifiedData }) => {
        return {
          url: `driver/${id}`,
          method: "PATCH",
          body: modifiedData,
        };
      },
      invalidatesTags: ["driver"],
    }),
    deleteDriver: builder.mutation({
      query: (id) => {
        return {
          url: `delete-user/${id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["driver"],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetAllDriverQuery,
  useAddDriverMutation,
  useUpdateDriverMutation,
  useDeleteDriverMutation,
} = driverApi;
